import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { api } from "@/lib/apiClient";

const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
const SOON = 7 * 864e5;

// Gold banner for retrogrades happening now or starting within 7 days. `only` limits to one planet.
export default function RetroBanner({ only, planets = ["Mercury", "Venus", "Mars"], className = "" }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/public/retrogrades").then(({ data }) => setRows(data.planets)).catch(() => {}); }, []);
  const now = Date.now();
  const live = rows.filter((r) => r.start && (only ? only.includes(r.planet) : planets.includes(r.planet))
    && (r.retrograde || new Date(r.start) - now < SOON));
  if (!live.length) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="retro-banner">
      {live.map((r) => (
        <Link key={r.planet} to={`/transits/${["Uranus", "Neptune"].includes(r.planet) ? "uranus-neptune" : r.planet.toLowerCase()}`} data-testid={`retro-banner-${r.planet.toLowerCase()}`}
          className="flex items-center gap-3 rounded-2xl border border-[#D4AF37]/60 bg-gradient-to-r from-[#2a2110] to-[#0F1523] px-4 py-3 hover:border-[#D4AF37] transition-colors">
          <RotateCcw size={18} className="gold-text shrink-0" />
          <span className="text-sm text-[#E8DCC4]">
            <span className="gold-text font-medium">{r.planet} {r.retrograde ? "is retrograde" : "turns retrograde soon"}</span>{" "}
            {r.retrograde ? `in ${r.start_sign} until ${fmt(r.end)}` : `on ${fmt(r.start)} in ${r.start_sign}, until ${fmt(r.end)}`}
          </span>
        </Link>
      ))}
    </div>
  );
}
